import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { func } from 'prop-types';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { get as getEnpoint } from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser
} from '../../modules/ajio-fetch/utils';
import Modal from '../../components/common/Modal';
import { showModal, hideModal } from '../../actions/modal.js';
import { tokenReCreateParser } from '../../modules/ajio-fetch/utils';
import { readCookie, getCookie } from '../../components/common/Cookie';
import { createAnonymousToken, setToken } from '../../actions/authUser';
import { getMyAccountDetailsResponse as setMyAccountDetailsResponse } from '../../actions/homeData';
import { login } from '../../userauth/actions/signinAction';
import { MY_ACCOUNT_NODE_API } from '../node-api-routes/my-account-node-api';
import { signout } from '../../userauth/actions/signinAction';
import { checkFingerPrintDetails } from '../../utils/fingerPrint.js';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';

const { editProfileAPI = '', updateEmailAPI = '' } = MY_ACCOUNT_NODE_API;

function setProfileData(profile = {}) {
  return {
    type: 'SET_PROFILE_DATA',
    profile
  };
}

export function resetProfileData() {
  return {
    type: 'RESET_PROFILE_DATA'
  };
}

function getProfileDataSuccess() {
  return {
    type: 'GET_PROFILE_DATA_SUCCESS',
    success: true
  };
}

function getProfileDataFail(error) {
  return {
    type: 'GET_PROFILE_DATA_FAIL',
    success: false
  };
}

function editProfDataSuccess() {
  return {
    type: 'EDIT_PROFILE_DATA_SUCCESS',
    editProfDatasuccess: true
  };
}

function editProfDataFail(error) {
  return {
    type: 'EDIT_PROFILE_DATA_FAIL',
    editProfDatasuccess: false
  };
}

function otpSentSuccess(otpObj) {
  return {
    type: 'OTP_SENT_SUCCESS',
    otpSentSuccess: true,
    otpResponseObj: otpObj
  };
}
function otpVerify(otpObj) {
  return {
    type: 'OTP_VERIFY',
    otpVerifyResponseObj: otpObj
  };
}

function emailOtpVerify(otpObj) {
  return {
    type: 'EMAIL_OTP_VERIFY',
    emailOtpVerifyResponseObj: otpObj
  };
}

function otpSentFail(error) {
  return {
    type: 'OTP_SENT_FAIL',
    otpSentSuccess: false
  };
}
export function clearOtpData() {
  return {
    type: 'CLEAR_OTP_DATA'
  };
}
function updateEmailResponse(res) {
  return {
    type: 'UPDATE_EMAIL',
    emailUpdate: res
  };
}

function updateBannerInfo(res) {
  return {
    type: 'BANNER_INFO',
    bannerInfo: res
  };
}

function updateCustomerInfo(res) {
  return {
    type: 'BANNER_CUSTOMER_INFO',
    customerInfo: {
      email: res.uid,
      mobile: res.mobileNumber,
      firstName: res.firstName,
      lastName: res.lastName,
      uuid: res.customerUuid,
      profileName: _isEmpty(_get(res, 'name', '')) ? 'User' : res.name
    }
  };
}

function updatePaymentInfo(res) {
  return {
    type: 'PAYMENT_INFO',
    paymentInfo: res
  };
}

function deletePaymentCard(paymentInstrumentID, paymentInfo) {
  let paymentInfoDel = { ...paymentInfo.paymentInfo };
  const cardAfterDeletion = paymentInfoDel.storedPaymentInstruments.map(element => {
    if (element.paymentInstrumentCode === 'SAVED_CARD') {
      let afterDeletion = element.paymentInstrumentsInfo.filter(
        ele => ele.paymentInstrumentId !== paymentInstrumentID
      );
      return { ...element, paymentInstrumentsInfo: afterDeletion };
    }
    return element;
  });

  const finalObj = { ...paymentInfoDel, storedPaymentInstruments: cardAfterDeletion };
  return {
    type: 'PAYMENT_INFO',
    paymentInfo: finalObj
  };
}

/*
  function to get the profile data details from API
*/

export function getProfileData(requestObj = {}) {
  let {
    isRequestOrginIsBrowser = false,
    isRequestFromReferAndEarn = false,
    request = {},
    setError = true
  } = requestObj;
  
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    if (isRequestOrginIsBrowser) {
      if(isRequestFromReferAndEarn) {
        console.log("🚀 ~ getProfileData ~ isRequestFromReferAndEarn:", isRequestFromReferAndEarn)
        apiEndPoint = `/api/my-account/getuserinfo`;

        let { headers: { host = '' } = {} } = request;

        body = {
          A: request.cookies.A,
          U: request.cookies.U,
          params: request?.params?.params || ''
        };
        
        console.log("🚀 ~ getProfileData ~ cookies:", request.cookies, apiEndPoint, JSON.stringify(body))
      }
      dispatch(showLoader('profile-loader'));
    } else {
      let { headers: { host = '' } = {}, params:{params = ''} = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/getuserinfo`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        params: params
      };
      console.log("🚀 ~ getProfileData ~ request:", request.cookies, apiEndPoint, body)
    }

    const screenName = request.cookies.SN || '';
    console.log("🚀 ~ getProfileData ~ cookies:", request.cookies, apiEndPoint, JSON.stringify(body))

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        response.screenNameFromCookie = screenName;
        console.log("🚀 ~ getProfileData ~ response:", response)
        dispatch(setProfileData(response));
        dispatch(getProfileDataSuccess());
        dispatch(hideLoader('profile-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        console.log("🚀 ~ getProfileData ~ statusCode:", statusCode, error)
        errorParser(error, statusCode).then((errorObj = {}) => {
          console.log("🚀 ~ errorParser ~ errorObj:", errorObj)
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getProfileData(requestObj)(dispatch);
            });
          }
          dispatch(getProfileDataFail(error));
          if(setError){
            dispatch(setErrorObject(errorObj));
          }
          dispatch(hideLoader('profile-loader'));
        });
          console.log("🚀 ~ errorParser ~ error:", error)
      });
  };
}

export function sendOTPMobile(mobNumberObj, callback) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/send-otp`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(mobNumberObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('mobile-num-popup'));
        dispatch(otpSentSuccess(response));
        dispatch(setErrorObject({}));
        callback();
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              sendOTPMobile(mobNumberObj, callback)(dispatch);
            })
            .catch(error => {
              dispatch(hideLoader('mobile-num-popup'));
              dispatch(otpSentFail(error));
              dispatch(setErrorObject(error));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
            });
        });
      });
  };
}

export function updateMobile(profileObj, callback) {
  return dispatch => {
    dispatch(showLoader('mobile-num-popup'));
    const apiEndPoint = `/api/my-account/update-mobile-number`;
    console.log(profileObj, 'profileObj');
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(profileObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log(response, 'response line 272');
        callback(response);
        // setTimeout(location.reload,1000);
        dispatch(hideLoader('mobile-num-popup'));
      })
      .catch(error => {
        dispatch(hideLoader('mobile-num-popup'));
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              updateMobile(profileObj)(dispatch);
            })
            .catch(error => {
              dispatch(editProfDataFail(error));
              dispatch(setErrorObject({ ...error, errorType:"wrong-otp", originator: 'contact-detail' }));
              // let timeout = setTimeout(() => {
              //   dispatch(setErrorObject({}));
              //   clearTimeout(timeout);
              // }, 5000);
            });
        });
      });
  };
}

export function cancelUpdateMobile(profileObj, callback) {
  return dispatch => {
    dispatch(showLoader('mobile-num-popup'));
    const apiEndPoint = `/api/my-account/cancel-update-mobile-number`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(profileObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        callback(response);
        dispatch(hideLoader('mobile-num-popup'));
      })
      .catch(error => {
        dispatch(hideLoader('mobile-num-popup'));
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          callback({ success: false, ...errorObj });
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              cancelUpdateMobile(profileObj, callback)(dispatch);
            })
            .catch(error => {
              dispatch(editProfDataFail(error));
              dispatch(setErrorObject({ ...error, originator: 'contact-detail' }));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
            });
        });
        console.log('In error case..............');
        callback();
      });
  };
}

export function editProfileData(editProfileObj, source) {
  return function(dispatch) {
    dispatch(showLoader('quickview-loader'));
    let apiEndPoint = `/api/my-account/edit-profile`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(editProfileObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setProfileData(response));
        dispatch(editProfDataSuccess());
        let messageBar = {
          errorType: 'info',
          pageType: 'personal-info',
          message: response.message || 'Your Personal Information has been updated.'
        };
        dispatch(setErrorObject(messageBar));
        dispatch(hideLoader('quickview-loader'));
        setTimeout(() => {
          location.reload();
        }, 2000);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        if (statusCode == 401) {
          if (source == 'mobile') {
            window.location = '/login';
          } else {
            dispatch(showModal('sign-in-up'));
            let messageBar = {
              errorType: 'info',
              pageType: 'personal-info',
              message: 'Your Personal Information has been updated.'
            };
            dispatch(setErrorObject(messageBar));
            dispatch(hideLoader('quickview-loader'));
          }
        } else {
          errorParser(error, statusCode).then((errorObj = {}) => {
            tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                editProfileData(editProfileObj)(dispatch);
              })
              .catch(error => {
                dispatch(editProfDataFail(error));
                dispatch(setErrorObject(error));
                dispatch(hideLoader('quickview-loader'));
                let timeout = setTimeout(() => {
                  dispatch(setErrorObject({}));
                  clearTimeout(timeout);
                }, 5000);
              });
          });
        }
      });
  };
}

export function updateEmail(data, callback) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    const TIMER = 2000;
    return fetcher(
      updateEmailAPI,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        dispatch(updateEmailResponse(serviceRes, data));
        if (serviceRes.statusCode === 201) {
          let messageBar = {
            originator: 'contact-detail',
            errorType: 'info',
            message: 'Your Email ID is updated with new Email ID.'
          };
          dispatch(setErrorObject(messageBar));
        }

        setTimeout(() => {
          callback();
          dispatch(hideLoader('mobile-num-popup'));
        }, TIMER);
      })
      .catch(err => {
        dispatch(hideLoader('mobile-num-popup'));
        let statusCode = getErrorStatusCode(err);
        errorParser(err, statusCode).then((errorObj = {}) => {
          // dispatch(hideLoader(""));
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              updateEmail(data, callback)(dispatch);
            });
          }
          dispatch(setErrorObject({ ...errorObj, originator: 'contact-detail' }));
        });
      });
  };
}

export function otpForUpdateEmail(mobNumberObj, callback) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/personal-info-otp`;
    const apiConfig = fetchGetJSONReqOpts({
      method: 'POST',
      body: JSON.stringify(mobNumberObj),
      headers: { 'content-type': 'application/json' },
      credentials: 'include'
    });
    console.log('🚀 ~ file: personalInfo.js:433 ~ returnfunction ~ apiConfig:', apiConfig);
    return fetcher(apiEndPoint, apiConfig)
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('🚀 ~ file: personalInfo.js:437 ~ returnfunction ~ response:', response);
        dispatch(hideLoader('mobile-num-popup'));
        dispatch(otpSentSuccess(response));
        dispatch(setErrorObject({}));
        callback();
      })
      .catch(err => {
        dispatch(hideLoader('mobile-num-popup'));
        let statusCode = getErrorStatusCode(err);
        errorParser(err, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              otpForUpdateEmail(data, callback)(dispatch);
            });
          }
          dispatch(setErrorObject({ ...errorObj, originator: 'contact-detail' }));
        });
      });
  };
}

export function verifyOtpForUpdateEmail(mobNumberObj, callback) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/updateEmail`;
    const apiConfig = fetchGetJSONReqOpts({
      method: 'POST',
      body: JSON.stringify(mobNumberObj),
      headers: { 'content-type': 'application/json' },
      credentials: 'include'
    });
    console.log('🚀 ~ file: personalInfo.js:469 ~ returnfunction ~ apiConfig:', apiConfig);
    return fetcher(apiEndPoint, apiConfig)
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('🚀 ~ file: personalInfo.js:473 ~ returnfunction ~ response:', response);
        dispatch(hideLoader('mobile-num-popup'));
        dispatch(otpSentSuccess(response));
        dispatch(setErrorObject({}));
        callback();
      })
      .catch(err => {
        dispatch(hideLoader('mobile-num-popup'));
        let statusCode = getErrorStatusCode(err);
        errorParser(err, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              verifyOtpForUpdateEmail(data, callback)(dispatch);
            });
          }
          dispatch(setErrorObject({ ...errorObj, originator: 'contact-detail' }));
        });
      });
  };
}

export function updatePassword(data, uaasFlag) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/edit-profile`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let messageBar = {
          errorType: 'info',
          pageType: 'personal-info',
          message: response.message || 'Your Password has been updated.'
        };
        dispatch(setErrorObject(messageBar));
        if (
          response.statusCode === '202' ||
          (uaasFlag && response?.statusCode === 200 && response?.success)
        ) {
          signout(() => {
            window.location = '/login';
          })();
        }
        dispatch(editProfDataSuccess());
        dispatch(hideLoader('mobile-num-popup'));
        setTimeout(() => {
          callback();
          dispatch(hideLoader('mobile-num-popup'));
        }, TIMER);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(err);
        errorParser(err, statusCode).then((errorObj = {}) => {
          // dispatch(hideLoader(""));
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              updatePassword(data)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}
export function getVerifyEmailOtp(callbackOtp) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/generate-email-otp`;
    const TIMER = 5000;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('mobile-num-popup'));
        dispatch(otpSentSuccess(response));
        callbackOtp && callbackOtp();
        dispatch(setErrorObject({}));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              getVerifyEmailOtp(callbackOtp)(dispatch);
            })
            .catch(error => {
              dispatch(hideLoader('mobile-num-popup'));
              dispatch(otpSentFail(error));
              dispatch(setErrorObject(error));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, TIMER);
            });
        });
      });
  };
}

export function verifyEmailOtp(otp, emailId, pageType) {
  return dispatch => {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('mobile-num-popup'));
        const verifyUserDetail = {
          otp,
          emailId
        };
        return fetcher(
          `/api/my-account/verify-email-otp`,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(verifyUserDetail),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            dispatch(hideLoader('mobile-num-popup'));
            const { statusCode = '', userDetails = {} } = response;
            if (statusCode == '0') {
              dispatch(setProfileData(userDetails));
              dispatch(editProfDataSuccess());
            }
            gtmEventPush({
              event: pageType == 'cart' ? 'coupon_interactions' : 'my_account_interactions',
              event_category:
                pageType == 'cart' ? 'coupon interactions' : 'my account interactions',
              event_label: statusCode == '0' ? 'success' : 'failure',
              event_action: 'email verification',
              screen_name: 'Employee verify email screen'
            });
            dispatch(emailOtpVerify(response));
            return Promise.resolve(response);
          })
          .catch(error => {
            let statusCode = getErrorStatusCode(error);
            errorParser(error, statusCode).then((errorObj = {}) => {
              tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  updateMobile(profileObj)(dispatch);
                })
                .catch(error => {
                  dispatch(editProfDataFail(error));
                  dispatch(setErrorObject(error));
                  let timeout = setTimeout(() => {
                    dispatch(setErrorObject({}));
                    clearTimeout(timeout);
                  }, 5000);
                  dispatch(hideLoader('mobile-num-popup'));
                  return Promise.reject(error);
                });
            });
            return Promise.reject(error);
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function getUserOtp(userDetailObj = {}, callbackOtp) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    let apiEndPoint = `/api/my-account/personal-info-otp`;
    const TIMER = 5000;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(userDetailObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('🚀 ~ file: personalInfo.js:608 ~ response:', response);
        dispatch(hideLoader('mobile-num-popup'));
        dispatch(showModal('otp-popup'));
        dispatch(otpSentSuccess(response));
        dispatch(setErrorObject({}));
        callbackOtp && callbackOtp();
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              getUserOtp(userDetailObj, callback)(dispatch);
            })
            .catch(error => {
              dispatch(hideLoader('mobile-num-popup'));
              dispatch(otpSentFail(error));
              dispatch(setErrorObject(error));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, TIMER);
            });
        });
      });
  };
}

export function verifyUserProfileOTP(
  otp,
  mobileNumber,
  isPaymentRelated = false,
  otpBody = {},
  isChangeMobileNumber = false
) {
  return dispatch => {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('mobile-num-popup'));
        let verifyUserDetail = {
          otp,
          mobileNumber,
          expireOTP: true,
          isPaymentRelated
        };
        if (Object.keys(otpBody).length && otpBody.isPaymentOtpApi) {
          verifyUserDetail = { ...verifyUserDetail, ...otpBody };
        }
        return fetcher(
          `/api/my-account/verify-user-profile`,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(verifyUserDetail),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            dispatch(hideLoader('mobile-num-popup'));

            const { statusCode = '' } = response;
            if (statusCode == '0') {
              dispatch(hideModal('otp-popup'));
              if (isChangeMobileNumber) dispatch(otpVerify(response));
            }
            if (!isChangeMobileNumber) dispatch(otpVerify(response));
            return Promise.resolve(response);
          })
          .catch(error => {
            let statusCode = getErrorStatusCode(error);
            errorParser(error, statusCode).then((errorObj = {}) => {
              tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  updateMobile(profileObj)(dispatch);
                })
                .catch(error => {
                  dispatch(editProfDataFail(error));
                  dispatch(setErrorObject(error));
                  let timeout = setTimeout(() => {
                    dispatch(setErrorObject({}));
                    clearTimeout(timeout);
                  }, 5000);
                  dispatch(hideLoader('mobile-num-popup'));
                  return Promise.reject(error);
                });
            });
            return Promise.reject(error);
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function getBannerResult(deviceType, showConvenienceFeeFlow) {
  return function(dispatch, getState) {
    return checkFingerPrintDetails()
      .then(() => {
        const body = {
          baseRequest: {
            consumerType: 'STOREFRONT',
            pageType: 'string',
            tenantId: 'AJIO',
            cartId: getCookie('C'),
            channelInfo: {
              appType: 'OTHER',
              appVersion: 'string',
              channelType: deviceType,
              deviceId: 'string',
              nthOrderOnChannel: 0,
              osType: 'WINDOW',
              osVersion: 'string',
              sessionId: 'string'
            },
            userInfo: {
              email: decodeURIComponent(
                _get(getState(), 'bannerInfo.customerInfo.email', getCookie('U'))
              ),
              phoneNumber: _get(getState(), 'bannerInfo.customerInfo.mobile', getCookie('MN')),
              profileName: _get(getState(), 'bannerInfo.customerInfo.profileName', getCookie('un')),
              userId: decodeURIComponent(
                _get(getState(), 'bannerInfo.customerInfo.uuid', getCookie('CI'))
              )
            }
          }
        };

        const apiEndPoint = `/api/my-account/banner-info`;
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              token: getCookie('A'),
              item: body,
              showConvenienceFeeFlow
            })
          })
        )
        .then(fetchGetJSONResHandler)
        .then(response => {
          dispatch(updateBannerInfo(response));
          return response; // ensure promise resolves with response
        })
        .catch(error => {
          const statusCode = getErrorStatusCode(error);
          return errorParser(error, statusCode).then((errorObj = {}) => {
            dispatch(setErrorObject(errorObj));
            throw errorObj; // propagate error
          });
        });
      })
      .catch(err => {
        const messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
        throw err; // propagate outer error
      });
  };
}

export function getBannerInfo(requestObj = {}) {
  let { request = {} } = requestObj;
  let body = {};
  return dispatch => {
    let { headers: { host = '' } = {} } = request;
    let apiEndPoint = `http://${host}/api/my-account/user-info`;
    body = {
      A: request.cookies.A,
      U: request.cookies.U
    };
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(updateCustomerInfo(response));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function getPaymentInfo(requestObj = {}) {
  let { request = {} } = requestObj;
  return (dispatch, getState) => {
    getBannerInfo((requestObj = {}), dispatch);
    let { headers: { host = '' } = {} } = request;
    let apiEndPoint = `http://${host}/api/my-account/payment-info`;
    const body = {
      U: _get(getState(), 'personalInfo.profile.customerUuid', request.cookies.CI),
      A: request.cookies.A
    };
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(updatePaymentInfo(response));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function deletePaymentInfo(paymentInsID, checkSum) {
  return (dispatch, getState) => {
    let apiEndPoint = `/api/my-account/delete-payment-info`;
    // let apiEndPoint = `/api/my-account/desagdhasgdfo`;

    const body = {
      U: _get(getState(), 'personalInfo.profile.customerUuid', getCookie('CI')),
      pID: paymentInsID,
      c: checkSum
    };
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(deletePaymentCard(paymentInsID, getState().paymentInfo));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function setUnauthedAccountLinks(requestObj = {}, clientType = '') {
  const { request = {} } = requestObj;
  const { enableMyAccountLinksCMS= false } = request;
  return async dispatch => {
    try {
      const deviceClient = clientType.toUpperCase() === 'MSITE' ? 'msite' : 'desktop';
      const apiEndPoint = getEnpoint('myaccount');
      const url = enableMyAccountLinksCMS ? `${getEnpoint('myAccountCMS')}&channel=${deviceClient}` : `${apiEndPoint}?componentId=MobNavMoreBar&pageId=CATEGORY&client_version=3.1&client_type=Android/23&format=json&client_type=${clientType}`;
      const rawResponse = await fetcher(
        url,
        fetchGetJSONReqOpts({
          method: 'GET',
          headers: {
            'content-type': 'application/json'
          }
        })
      );
      const response = await fetchGetJSONResHandler(rawResponse);
      if (response) {
        dispatch(setMyAccountDetailsResponse(response));
      } else {
        dispatch(setMyAccountDetailsResponse({}));
      }
    } catch (error) {
      const statusCode = getErrorStatusCode(error);
      const errorObj = await errorParser(error, statusCode);
      dispatch(setErrorObject(errorObj));
    }
  };
}

export function updateAccountVerificationDetails(profileObj) {
  return function(dispatch) {
    dispatch(showLoader('mobile-num-popup'));
    return fetcher(
      editProfileAPI,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(profileObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('🚀 ~ file: personalInfo.js:908 ~ returnfunction ~ response:', response);
        if (response.hasOwnProperty('message')) {
          let messageBar = {
            errorType: 'error',
            message: response.message
          };
          dispatch(setErrorObject(response));
        } else {
          dispatch(setErrorObject({}));
          dispatch(hideModal('update-mobile'));
        }
        dispatch(hideLoader('mobile-num-popup'));
      })
      .catch(error => {
        dispatch(hideLoader('mobile-num-popup'));
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, mobile number is not updated...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function deleteUserAccount(reason = {}) {
  return function(dispatch) {
        dispatch(showLoader('mobile-num-popup'));
        return fetcher(
          `/api/my-account/account-delete`,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(reason),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            dispatch(hideLoader('mobile-num-popup'));
            return Promise.resolve(response);
          })
          .catch(error => {
            dispatch(hideLoader('mobile-num-popup'));
            return Promise.reject(error);
          });
  };
}
